var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{ref:"box",staticClass:"box"},[_c('div',{ref:"marquee",staticClass:"marquee"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{ref:"copy",staticClass:"copy"})]),_vm._v(" "),_c('div',{ref:"node",staticClass:"node"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f8c6ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/nationNew.vue
// module id = null
// module chunks = 